import { StyleSheet } from "react-native"
import { colors } from "colors"
import { typography } from "theme"

export const style = StyleSheet.create({
  voucherContainer: {
    flex: 1,
    justifyContent: "space-around",
    height: "100%",
  },
  leftCurved: {
    position: "absolute",
    width: 30,
    height: 30,
    borderRadius: 100,
    backgroundColor: `white`,
    top: 45,
    left: -15,
    zIndex: 1,
  },
  rightCurved: {
    position: "absolute",
    width: 30,
    height: 30,
    borderRadius: 100,
    backgroundColor: `white`,
    top: 45,
    right: -15,
    zIndex: 1,
  },
  voucherContentContainer: {
    borderRadius: 10,
    marginTop: 10,
    padding: 20,
    paddingLeft: 0,
    paddingRight: 0,
    position: "relative",
    borderWidth: 0,
  },
  voucherText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
  },
  voucherTitleText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 16,
    fontWeight: "bold",
  },
  row: { alignItems: "center", flexDirection: "row", flex: 1, paddingHorizontal: 20, height: 100 },
  expiryText: {
    color: colors.white,
    fontFamily: typography.primary.normal,
    fontSize: 11,
    marginBottom: 5,
  },
  image: {
    width: 80,
    height: 80,
    alignSelf: "flex-end",
    borderRadius: 15,
    marginRight: 5,
  },
  dottedLine: {
    marginRight: 10,
    marginVertical: 4,
  },
  countDownContainer: {
    width: "20%",
    alignItems: "center",
    justifyContent: "center",
  },
  countDown: {
    width: 100,
    height: 100,
    zIndex: 999,
  },
  expiredClaimedImage: {
    width: 100,
    height: 100,
    position: "absolute",
    right: 15,
    bottom: 10,
    zIndex: 999,
    opacity: 0.8,
  },
})
